import React, { Component } from 'react';

import JournalDbRegister from "./0_journal_db_register"
import JournalCategories from "./2_journal_categories"

class Categories extends Component {
    constructor(props) {
      super(props);
    }

    render() {
        return (
          <>
            <JournalDbRegister />

            <JournalCategories />
          </>
        )
    }
}

export default Categories;
